"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NirgalBot = void 0;
const Card_1 = require("../Card");
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const CardRenderer_1 = require("../render/CardRenderer");
const Size_1 = require("../render/Size");
const Milestones_1 = require("../../milestones/Milestones");
const Dealer_1 = require("../../Dealer");
class NirgalBot extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.CORPORATION,
            name: CardName_1.CardName.NIRGAL_BOT,
            startingMegaCredits: 0,
            metadata: {
                cardNumber: 'AU13',
                description: 'During setup, put a random milestone into play.',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.corpBox('action', (ce) => {
                        ce.vSpace(Size_1.Size.LARGE);
                        ce.vSpace(Size_1.Size.LARGE);
                        ce.text('Action: Put a random milestone into play', Size_1.Size.MEDIUM, true);
                        ce.vSpace(Size_1.Size.SMALL);
                        ce.vSpace(Size_1.Size.LARGE);
                    });
                }),
            },
        });
    }
    play() {
        return undefined;
    }
    initialAction(player) {
        this.putRandomMilestoneIntoPlay(player.game);
        return undefined;
    }
    canAct() {
        return true;
    }
    action(player) {
        this.putRandomMilestoneIntoPlay(player.game);
        return undefined;
    }
    putRandomMilestoneIntoPlay(game) {
        let availableMilestones = Milestones_1.ALL_MILESTONES.filter((milestone) => {
            if (game.milestones.includes(milestone))
                return false;
            if (!game.gameOptions.venusNextExtension && milestone.name === 'Morningstar')
                return false;
            if (!game.gameOptions.coloniesExtension && milestone.name === 'Colonizer')
                return false;
            if (!game.gameOptions.turmoilExtension && milestone.name === 'Lobbyist')
                return false;
            if (!game.gameOptions.turmoilExtension && milestone.name === 'Politician')
                return false;
            if (!game.gameOptions.turmoilExtension && milestone.name === 'Ambassador')
                return false;
            if (!game.gameOptions.aresExtension && milestone.name === 'Purifier')
                return false;
            if (!game.gameOptions.moonExpansion) {
                if (Milestones_1.MOON_MILESTONES.includes(milestone))
                    return false;
            }
            if (!game.gameOptions.newOpsExpansion) {
                if (Milestones_1.NEW_OPS_MILESTONES.includes(milestone))
                    return false;
            }
            if (!game.gameOptions.preludeTwoExtension) {
                if (Milestones_1.PRELUDE_TWO_MILESTONES.includes(milestone))
                    return false;
            }
            return true;
        });
        availableMilestones = Dealer_1.Dealer.shuffle(availableMilestones);
        if (availableMilestones.length > 0) {
            const randomMilestone = availableMilestones[0];
            game.milestones.push(randomMilestone);
            game.log('${0} action: Put ${1} milestone into play', (b) => b.card(this).milestone(randomMilestone));
        }
        else {
            game.automaBotVictoryPointsBreakdown.terraformRating++;
            game.log('${0} action: Gain 1 TR as there are no available milestones left', (b) => b.card(this));
        }
    }
}
exports.NirgalBot = NirgalBot;
//# sourceMappingURL=NirgalBot.js.map